export default __webpack_public_path__ + "static/cafe_36080-ac745b83a2b0df79e3482b99dccdfee8.png";